import React from 'react';
export default function Collapse(props: React.SVGProps<SVGSVGElement>) {
  return <svg width={23} height={2} viewBox="0 0 23 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="Collapse" data-sentry-source-file="collapse.tsx">
            <path d="M1 1H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-sentry-element="path" data-sentry-source-file="collapse.tsx" />
        </svg>;
}